import { css } from '@emotion/react'
import { type ForwardedRef, forwardRef, type ReactNode } from 'react'
import { mediaQueryHookQueries, useMediaQuery } from '../../..'

interface WrapperProps {
  children?: ReactNode
  className?: string
}

export const FlexWrapper = ({ children, className }: WrapperProps) => (
  <div
    className={className}
    css={css`
      display: flex;
      flex: 1 1 auto;
      height: 100%;
      overflow: hidden;
      position: relative;
      min-height: 100vh;
    `}
  >
    {children}
  </div>
)

export const SideMenuWrapper = ({ children, className }: WrapperProps) => (
  <aside
    className={className}
    css={css`
      display: flex;
      flex: 0 0 auto;
    `}
  >
    {children}
  </aside>
)

export const ContentWrapper = forwardRef<HTMLDivElement, WrapperProps>(
  ({ children, className }, ref: ForwardedRef<HTMLDivElement>) => {
    const isMdOver = useMediaQuery(mediaQueryHookQueries.mdOver)

    return (
      <div
        className={className}
        css={css`
          display: flex;
          flex: 1 1 auto;
          flex-direction: column;
          overflow-y: auto;
          position: ${isMdOver && 'relative'};
          z-index: 98;
        `}
        ref={ref}
      >
        {children}
      </div>
    )
  }
)
